export default __webpack_public_path__ + "static/coloredited_danalim_data_croads-fda2117c986dfd78e9275a862dbd58c4.png";